import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { OTPInput } from '@/components/blocks/OTPInput';
import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
	otp: string;
	otpError?: string;
	disabled?: boolean;
	sendCooldownSeconds: number;
	cooldownStartedAt?: number;
	onChangeOtp: (otp: string) => void;
	onSubmitLogin: () => void;
	onSubmitOtpMethod: () => void;
	onToggleSelectOtpMethod: () => void;
};

export const LoginOtpStage: React.FC<Props> = ({
	otp,
	otpError,
	disabled,
	sendCooldownSeconds,
	cooldownStartedAt,
	onChangeOtp,
	onSubmitLogin,
	onSubmitOtpMethod,
	onToggleSelectOtpMethod,
}) => {
	const [now, setNow] = useState(() => Date.now());

	useEffect(() => {
		setNow(Date.now());

		if (!cooldownStartedAt) return;
		if (Date.now() - cooldownStartedAt >= sendCooldownSeconds * 1000) return;

		const interval = window.setInterval(() => {
			const currentNow = Date.now();
			setNow(currentNow);

			if (currentNow - cooldownStartedAt >= sendCooldownSeconds * 1000) {
				window.clearInterval(interval);
			}
		}, 1000);

		return () => window.clearInterval(interval);
	}, [cooldownStartedAt, sendCooldownSeconds]);

	const remainingTime = cooldownStartedAt
		? Math.max(0, sendCooldownSeconds - Math.floor((now - cooldownStartedAt) / 1000))
		: 0;

	const handleOnSendOtp = () => {
		if (remainingTime === 0) {
			onSubmitOtpMethod();
		}
	};

	return (
		<Stack width="100%">
			<OTPInput value={otp} error={otpError} onChange={onChangeOtp} onComplete={onSubmitLogin} />

			<DpButton
				sx={{
					mt: '20px',
					alignSelf: 'flex-end',
					'&:disabled': { color: 'var(--color-text-disabled)', cursor: 'not-allowed' },
				}}
				variant="text"
				disabled={remainingTime > 0}
				onClick={handleOnSendOtp}
			>
				{remainingTime > 0
					? `Reenviar código (${Math.floor(remainingTime / 60)
							.toString()
							.padStart(2, '0')}:${(remainingTime % 60).toString().padStart(2, '0')})`
					: 'Reenviar código'}
			</DpButton>

			<DpButton
				sx={{ mt: '20px', width: '100%', maxWidth: '400px', alignSelf: 'center' }}
				id="button-login-otp-submit"
				disabled={disabled}
				onClick={onSubmitLogin}
			>
				{'Iniciar sesión'}
			</DpButton>

			<DpButton sx={{ mt: '20px' }} variant="text" onClick={onToggleSelectOtpMethod}>
				{'Probar otro método'}
			</DpButton>
		</Stack>
	);
};
